import { atom, useSetAtom } from "jotai";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken"; // Assuming you want to reuse your fetch wrapper
import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { ReportMenuItem } from "@/functions/Interfaces/LaporanInterfaces";

// Private Atom (Writeable only internally)
const _internalReportMenuAtom = atom<ReportMenuItem[] | null>(null);

// Public Atom (Read-only for components)
export const reportMenuAtom = atom((get) => get(_internalReportMenuAtom));

export const useLoadReportMenu = () => {
    const setReportMenu = useSetAtom(_internalReportMenuAtom);
    const { fetchGET } = useFetchWithAccessToken(); // Optional: use your existing fetcher

    const loadReportMenu = async () => {
        try {
            const res = await fetchGET<ReportMenuItem[]>(BackendApiUrl.reporting.getReportMenuItem);

            if (res.problem || res.error) {
                console.error(res.problem || res.error);
                setReportMenu([]);
            } else {
                setReportMenu(res.data || []);
            }
        } catch (error) {
            console.error("Error fetching reportMenu:", error);
            setReportMenu([]);
        }
    };

    return loadReportMenu;
};